"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.format = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./sass/InputCreditCard.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _visa = _interopRequireDefault(require("./assets/visa.svg"));

var _mc_symbol = _interopRequireDefault(require("./assets/mc_symbol.svg"));

var _americanExpress = _interopRequireDefault(require("./assets/american-express.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var format = function format(value, mask) {
  var i = 0;
  var lastReplacedIndex = -1;
  var filledMask = mask.replace(/#/g, function (_, j) {
    if (i >= value.length) {
      return '#';
    }

    lastReplacedIndex = j;
    return value[i++];
  });
  return filledMask.substring(0, lastReplacedIndex + 1);
};

exports.format = format;

var InputCreditCard = function InputCreditCard(_ref) {
  var state = _ref.state,
      id = _ref.id,
      setCardData = _ref.setCardData;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      card = _useState2[0],
      setCard = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      typeCard = _useState4[0],
      setTypeCard = _useState4[1];

  var handleChange = function handleChange(e) {
    var numberRaw = e.target.value;
    var number = e.target.value;
    setCard(number.replace(/\D/g, ''));
    var typeCard = number.substring(0, 2);

    if (typeCard >= '51' && typeCard <= '55') {
      setTypeCard('Master Card');
    } else if (typeCard >= '40' && typeCard <= '49') {
      setTypeCard('Visa');
    } else if (typeCard === '34' || typeCard === '37') {
      setTypeCard('American Express');
    } else {
      setTypeCard('Cards');
    }

    setCardData(_objectSpread(_objectSpread({}, state), {}, {
      cardNumber: numberRaw
    }));
  };

  var masterClass = {
    'master-active': typeCard === 'Master Card'
  };
  var visaClass = {
    'master-active': typeCard === 'Visa'
  };
  var americanClass = {
    'master-active': typeCard === 'American Express'
  };
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "labelCard"
  }, /*#__PURE__*/_react.default.createElement("legend", null, "Card Number"), /*#__PURE__*/_react.default.createElement("input", {
    onChange: handleChange,
    value: format(card, '#### #### #### ####'),
    type: "tel",
    id: id,
    name: id,
    inputMode: "numeric",
    autoComplete: "cc-number",
    maxLength: "19",
    className: "labelCard-input" // disabled

  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "logos"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _visa.default,
    alt: "Visa Card",
    className: (0, _classnames.default)('logos-img', visaClass)
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _mc_symbol.default,
    alt: "Master Card",
    className: (0, _classnames.default)('logos-img', masterClass)
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _americanExpress.default,
    alt: "American Express Card",
    className: (0, _classnames.default)('logos-img', americanClass)
  })));
};

InputCreditCard.propTypes = {
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  setCardData: _propTypes.default.func,
  state: _propTypes.default.any
};
var _default = InputCreditCard;
exports.default = _default;